import { create } from 'zustand';

// ParticipationStatus 열거형 정의
export enum ParticipationStatus {
  CHECK_ELIGIBLE = 1, // 참가권 확인 가능(개인정보 동의 완료)
  NOT_AGREED = 2, // 참가권 받기 전(개인정보 동의 전)
  NO_TICKETS = 3, // 획득한 참가권 없음
}

type TicketNumberType = {
  ticketNo: number;
  usedYn: string;
};

interface FlightData {
  allowDuplicateIssue?: 'Y' | 'N';
  status: ParticipationStatus;
  ticketCnt: number;
  entryGroupSrl?: number;
  userTicketInfo: TicketNumberType[] | null;
  ticketUseYn?: 'Y' | 'N';
  ticketPassword?: string | null;
  version?: string;
}

interface InfoState {
  info: FlightData;
  setInfo: (data: Partial<FlightData>) => void;
}

// Zustand 스토어 생성
const infoStore = create<InfoState>((set) => ({
  info: {
    status: ParticipationStatus.NO_TICKETS,
    ticketCnt: 0,
    userTicketInfo: null,
    ticketUseYn: 'N',
    ticketPassword: null,
    version: '',
  },
  setInfo: (data: Partial<FlightData>) =>
    set((state) => ({
      info: {
        ...state.info,
        ...data,
      },
    })),
}));

export { infoStore };
